import { useMobile } from "@/hooks";
import trackClevertapEvents from "@/utils/trackClevertapEvents";
import { Modal } from "@monsterindia/global-ui-components";
import React from "react";

import { ResubscribeCompaniesPage } from "../../unsubscribe/components/ResubscribeCompaniesPage";
import { OutreachSubscriptionState } from "../../unsubscribe/types/unsubscribe";

type ResubscribeCompaniesModalProps = {
  outreachSubscriptionData: any;
  setOutreachSubscriptionData: React.Dispatch<
    React.SetStateAction<OutreachSubscriptionState>
  >;
};

const ResubscribeCompaniesModal: React.FC<ResubscribeCompaniesModalProps> = ({
  outreachSubscriptionData,
  setOutreachSubscriptionData,
}) => {
  const isMobile = useMobile();

  const handleCloseModal = () => {
    setOutreachSubscriptionData({
      ...outreachSubscriptionData,
      resubscribeModalOpen: false,
    });
  };

  return (
    <div className="">
      <Modal
        screenAlignment={isMobile ? "bottom-sheet" : "center"}
        showModal={outreachSubscriptionData.resubscribeModalOpen}
        closeModal={handleCloseModal}
        showCloseButton={true}
        showHandleBar={isMobile}
        customClass="dark:ring-white/10rounded-lg shadow-elev-large md:mx-auto md:max-w-2xl rounded-2xl bg-[#fff] bg-white p-0 shadow-xl ring-1 ring-black/5 dark:bg-neutral-900"
      >
        <ResubscribeCompaniesPage
          setOutreachSubscriptionData={setOutreachSubscriptionData}
          outreachSubscriptionData={outreachSubscriptionData}
        />
      </Modal>
    </div>
  );
};

export default ResubscribeCompaniesModal;
